import { PaymentOptionsContent } from 'lib/types/payment';

export const gwatFallbackData: PaymentOptionsContent[] = [
  {
    title: 'VIP+ Booking',
    type: 'VIP',
    entries: [
      {
        content: 'Get our best discount available.',
      },
      {
        content: 'Highest priority for trip dates.',
      },
      {
        popup: {
          content:
            'You can change your choices for free with your Trip Coordinator well after you get started today, until usually 84 days before departure. (TCs apply)',
        },
        content: 'Destination & dates still changeable.',
      },
      {
        content: "100% refundable if you don't qualify today.",
      },
    ],
  },
  {
    title: 'VIP Deposit',
    type: 'Standard',
    entries: [
      {
        content: '<strong>Fast-track</strong> in front of non-vip bookings.',
      },
      {
        popup: {
          content:
            'You can change your choices for free with your Trip Coordinator well after you get started today, until usually 84 days before departure. (TCs apply)',
        },
        content: 'Flexible trip changes. Cancel anytime.',
      },
      {
        popup: {
          content:
            'Swap your trip, gift it or save it for later with our Lifetime Deposit Guarantee. (TCs apply)',
        },
        content: 'Protected by our Lifetime Deposit Guarantee.',
      },
      {
        content: "100% refundable if you don't qualify today.",
      },
    ],
  },
  {
    title: 'Promo Deposit',
    type: 'Promotional',
    entries: [
      {
        content: 'Spots limited. First in, first served.',
      },
      {
        content: 'Check if you qualify. Free to cancel.',
      },
      {
        popup: {
          content:
            'You can change your choices for free with your Trip Coordinator well after you get started today, until usually 84 days before departure. (TCs apply)',
        },
        content: 'Dates & destination changeable.',
      },
    ],
  },
  {
    title: 'VIP Booking',
    type: 'LITE-VIP',
    entries: [
      {
        content: 'Instant access to gWorld incl. Local Jobs board.',
      },
      {
        content: 'Join your Social group to meet others.',
      },
      {
        content: 'Flexible dates in case your plans change.',
        popup: {
          content:
            'You can change your choices for free with your Trip Coordinator well after you get started today, until usually 84 days before departure. (TCs apply)',
        },
      },
      {
        content: "100% refundable if you don't qualify today.",
      },
    ],
  },
];

export const dealsawayFallbackData: PaymentOptionsContent[] = [
  {
    title: 'Pay in full',
    type: 'VIP',
    entries: [
      {
        content: 'Priority service to request your dates.',
        popup: null,
      },
      {
        content: 'Personal Deal Expert to finalise the details.',
        popup: null,
      },
      {
        content: 'No card surcharge.',
        popup: null,
      },
      {
        content: '0% interest payment options with providers below.',
        popup: null,
      },
    ],
  },
  {
    title: 'Get started',
    type: 'Standard',
    entries: [
      {
        content: 'Get answers and tailor your trip.',
        popup: null,
      },
      {
        content: 'Finalise your dates and travellers together.',
        popup: null,
      },
      {
        content: 'Discuss a payment arrangement that suits you.',
        popup: null,
      },
      {
        content: 'No further automatic card charges.',
        popup: null,
      },
    ],
  },
];

export const mainPaymentOptions = ['deposit', 'standard', 'trip_in_full'];
